export default function validateInfo(values) {
    let errors = {};
  
    //check for incorrect pass first
  if (values == "incorrect pass") {
    errors.email = "Incorrect password and/or combination";
    return errors;
  }
    //check for invalid email format
    if (!values.email) {
      errors.email = 'Email required';
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = 'Email address is invalid';
    }
  
    //check for empty password and password length
    if (!values.password) {
      errors.password = 'Password is required';
    } else if (values.password.length < 6) {
      errors.password = 'Password needs to be 6 characters or more';
    }

    // check for empty account type
    if (!values.account) {
      errors.account = 'Required'
    } else if (values.account != 'Adopter' && values.account != 'Shelter') {
      errors.account = 'Required'
    }

    return errors;
  }